// extracted by mini-css-extract-plugin
export default {"link":"aL-z","disabled":"bL-z"};